<div class="address_body">
    <h3>Change your plan type</h3>
    <!-- <p>What type of a property are you looking to cover?</p> -->
    <span (click)="close()" class="close">
      <img src="https://cdn.elitehw.com/images/cross.webp" />
    </span>
  
    <div class="formarea">
        <form [formGroup]="planTypeForm">
      <div class="inputprt">
        <mat-form-field appearance="outline">
          <mat-select formControlName="planType">
          <mat-option value="PAY MONTHLY">MONTHLY</mat-option>
          <mat-option value="PAY ANNUALLY">ANNUALLY</mat-option>
          <mat-option value="displayTwoYearlyPrice">2 YEARS</mat-option>
          <mat-option value="displayThreeYearlyPrice">3 YEARS</mat-option>
          <mat-option value="displayFourYearlyPrice">4 YEARS</mat-option>
          <mat-option value="displayFiveYearlyPrice">5 YEARS</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="button_area">
        <button type="button" (click)="close()" class="cancel">Cancel</button>
        <button type="button" (click)="update()" class="updatebtn">Update</button>
      </div>
    </form>
    </div>
  </div>
  